export function formatDate(value) {
  if (!value) return null;

  // Pastikan value dalam bentuk string
  const str = String(value).trim();

  // Ganti spasi tunggal atau ganda dengan "T"
  const normalized = str.replace(/\s+/, "T");

  // Buat objek tanggal
  const d = new Date(normalized);

  // Cek apakah tanggal valid
  if (isNaN(d.getTime())) return null;

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${day}/${month}/${year}`;
}

export function formatDateTime(value) {
  if (!value) return null;

  // Pastikan value dalam bentuk string
  const str = String(value).trim();

  // Ubah "YYYY-MM-DD HH:mm:ss" menjadi "YYYY/MM/DD HH:mm:ss"
  // agar compatible dengan new Date()
  const normalized = str.replace(/-/g, "/");

  // Buat objek tanggal
  const d = new Date(normalized);

  // Cek apakah tanggal valid
  if (isNaN(d.getTime())) return null;

  const pad = (n) => String(n).padStart(2, "0");

  const year = d.getFullYear();
  const month = pad(d.getMonth() + 1);
  const day = pad(d.getDate());

  const hh = pad(d.getHours());
  const mm = pad(d.getMinutes());
  const ss = pad(d.getSeconds());

  return `${day}/${month}/${year} ${hh}:${mm}:${ss}`;
}
